import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { PanelComponent } from '@components/core-template/panel/panel.component';
import { MicrosoftAuthService } from '@services/core/authentication.service';
import { Global } from '@services/core/Global';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-movement-import',
  standalone: true,
  imports: [FormsModule, PanelComponent],
  templateUrl: './movement-import.component.html',
  styleUrls: ['./movement-import.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MovementImportComponent {
  private _http = inject(HttpClient)
  private _authService = inject(MicrosoftAuthService)
  private destroyRef = inject(DestroyRef)
  private cdr = inject(ChangeDetectorRef)

  protected sheets = [
    { index: 0, name: 'Incorporación' },
    { index: 1, name: 'Traslado Póliza' },
    { index: 2, name: 'Traslado Grupo' },
    { index: 3, name: 'Modificar Capital' },
    { index: 4, name: 'Exclusión' },
  ]
  protected selectedSheet = 0
  protected filesToUpload: File[] | null = null
  protected fileName: string | null = null
  protected importResult: { imported: number; errors: { row: number; message: string }[] } | null = null
  protected loading = false

  protected Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  })

  fileChangeEvent(fileInput: any) {
    this.importResult = null
    const files = fileInput.target.files
    if (files.length === 1) {
      this.filesToUpload = [files[0]]
      this.fileName = files[0].name
    } else {
      this.Toast.fire({ title: 'Seleccione un archivo .xlsx', icon: 'info' })
    }
  }

  clearFile() {
    this.filesToUpload = null
    this.fileName = null
    this.importResult = null
  }

  uploadFile() {
    if (!this.filesToUpload || this.filesToUpload.length === 0) {
      this.Toast.fire({ title: 'Seleccione un archivo Excel', icon: 'info' })
      return
    }

    this.loading = true
    this.importResult = null

    Swal.fire({
      text: 'Procesando archivo...',
      didOpen: () => Swal.showLoading(),
    })

    const formData = new FormData()
    formData.append('file', this.filesToUpload[0], this.filesToUpload[0].name)
    formData.append('sheet', String(this.selectedSheet))

    this._http.post(Global.url_seguros + 'import/movements', formData, {
      headers: {
        'Authorization': this._authService.getToken(),
        'Accept': 'application/json; charset=utf-8'
      }
    }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (res: any) => {
        Swal.close()
        this.loading = false
        this.importResult = res
        const msg = res.imported + ' registros importados' +
          (res.errors.length > 0 ? ', ' + res.errors.length + ' errores' : '')
        this.Toast.fire({ title: msg, icon: res.errors.length > 0 ? 'warning' : 'success' })
        this.cdr.markForCheck()
      },
      error: () => {
        Swal.close()
        this.loading = false
        this.Toast.fire({ title: 'Error al procesar archivo', icon: 'error' })
        this.cdr.markForCheck()
      }
    })
  }
}
